import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import classes from './BurgerBuilder.css';
import axios from '../../axios-orders';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler.jsx';
import Burger from '../../components/Burger/Burger.jsx';
import BuildControls from '../../components/Burger/BuildControls/BuildControls.jsx';
import Modal from '../../components/UI/Modal/Modal.jsx';
import OrderSummary from '../../components/Burger/OrderSummary/OrderSummary.jsx';
import Spinner from '../../components/UI/Spinner/Spinner';
import PageErrorMessage from '../../components/miscUtility/pageErrorMessage/PageErrorMessage.jsx';
import * as actionCreators from '../../store/actions/index';

export class BurgerBuilder extends Component {

  componentDidMount() {
    setTimeout(() => {
      if (this.props.token && !this.props.isBuilding) {
        this.props.GetBurgerData(this.props.token, this.props.userId);
      } else if (this.props.token) {
        this.props.SetServerBurgerData(this.props.token, this.props.userId, this.props.ingredients)
      } else {
        this.props.SetLocalBurgerData(null)
      }
    }, 0)
  }

  componentDidUpdate(prevProps) {
    if (localStorage.getItem('expirationDate') && new Date(localStorage.getItem('expirationDate')).getTime() <= new Date().getTime()) {
      this.props.Logout();
    }

    if (prevProps.ingredients && (prevProps.ingredients !== this.props.ingredients)) {
      if (this.props.token) {
        this.props.SetServerBurgerData(this.props.token, this.props.userId, this.props.ingredients)
      }
    }
  }

  componentWillUnmount() {
    if (this.props.error) {
      this.props.ClearPageError();
    }
  }


  buttonActiveCheck = (ingredients) => {
    const totalIngredients = Object.values(ingredients).reduce((sum, added) => sum + added, 0);
    return totalIngredients > 0;
  }

  continueToCheckout = () => {
    if (this.props.token) {
      this.props.history.replace({ pathname: '/checkout' });
      this.props.ToggleModal();
    } else {
      this.props.ToggleModal();
      this.props.SetLoginRedirect('/checkout');
      this.props.history.push('/authenticate/login')
    }
  }

  render() {

    let orderSummary = null;
    let burger = this.props.error ? <PageErrorMessage /> : <Spinner center={true} />
    let buildControls = null;

    if (this.props.ingredients) {
      burger = <Burger price={this.props.totalPrice} ingredients={this.props.ingredients} />

      buildControls = <BuildControls
        ingredients={this.props.ingredients}
        price={this.props.totalPrice}
        purchaseable={this.buttonActiveCheck(this.props.ingredients)}
        addIngredient={this.props.AddIngredient}
        removeIngredient={this.props.RemoveIngredient}
        openModal={this.props.ToggleModal} />

      orderSummary = <OrderSummary
        ingredients={this.props.ingredients}
        prices={this.props.ingredientPrices}
        total={this.props.totalPrice}
        cancel={this.props.ToggleModal}
        continue={this.continueToCheckout}
        isAuth={this.props.token !== null} />

    }



    return (
      <div className={classes.BurgerBuilder} >

        <Modal show={this.props.showModal}
          clicked={this.props.ToggleModal}>
          {orderSummary}
        </Modal>
        <Fragment>
          {burger}
          {buildControls}
        </Fragment>
      </div>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    ingredientPrices: state.burger.ingredientPrices,
    ingredients: state.burger.ingredients,
    totalPrice: state.burger.totalPrice,
    nextOrderID: state.orders.nextOrderID,
    purchaseable: state.burger.purchaseable,
    error: state.global.error,
    showModal: state.global.showModal,
    token: state.auth.token,
    userId: state.auth.userId,
    isBuilding: state.burger.isBuilding
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AddIngredient: (ingredient) => dispatch(actionCreators.addIngredient(ingredient)),
    RemoveIngredient: (ingredient) => dispatch(actionCreators.removeIngredient(ingredient)),
    SetIsBuilding: (isBuilding) => dispatch(actionCreators.setIsBuilding(isBuilding)),
    GetBurgerData: (token, userId) => dispatch(actionCreators.getBurgerData(token, userId)),
    ToggleModal: () => dispatch(actionCreators.toggleModal()),
    SetLocalBurgerData: (ingredients) => dispatch(actionCreators.setBurgerData(ingredients)),
    SetServerBurgerData: (token, userId, ingredients) => dispatch(actionCreators.setServerBurgerData(token, userId, ingredients)),
    ClearPageError: () => dispatch(actionCreators.clearPageError()),
    SetLoginRedirect: (redirectLocation) => dispatch(actionCreators.setLoginRedirect(redirectLocation)),
    Logout: () => dispatch(actionCreators.logout())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(BurgerBuilder, axios));



// WEBPACK FOOTER //
// ./src/containers/BurgerBuilder/BurgerBuilder.jsx